import React from 'react';
import PropTypes from 'prop-types';
import {getWidgetValue} from "sportinglife-react-common/widgets";
import withErrorBoundary from "../../../Errors/components/withErrorBoundry";

const TextAreaWidget = ({widget}) => {
  const textContent = getWidgetValue(widget, "html");

  // eslint-disable-next-line react/no-danger
  return <div className="news-article-body-text" dangerouslySetInnerHTML={{__html: textContent}} />;
};

TextAreaWidget.mapProps = (props) => ({
  widget: props.widget
})
TextAreaWidget.propTypes = {
  widget: PropTypes.object
}

export default withErrorBoundary(TextAreaWidget);



// WEBPACK FOOTER //
// ./modules/News/components/widgets/TextArea.widget.js